// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 2H2V22H11V17H13V22H22V2H13V7H11V2ZM17.1823 10.2321L15.4146 11.9999L17.1823 13.7676L15.7681 15.1818L12.5861 11.9999L15.7681 8.81787L17.1823 10.2321ZM8.33023 8.81825L11.5122 12.0002L8.33023 15.1822L6.91602 13.768L8.68378 12.0002L6.91602 10.2325L8.33023 8.81825Z"}}]};

const MergeCellsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'merge-cells-filled',
    ref,
    icon: element,
  },
));

MergeCellsFilledIcon.displayName = 'MergeCellsFilledIcon';

export default MergeCellsFilledIcon;
